// String
import { Strings } from "../../resources/i18n/i18n";

export const SIGNUP_REQUEST_STATUS_LIST = [
  { label: Strings("PENDING"), value: "PENDING" },
  { label: Strings("APPROVED"), value: "APPROVED" },
  { label: Strings("REJECTED"), value: "REJECTED" },
  { label: Strings("existing"), value: "EXISTING" },
];
